<template>
	<div id="app" :class="[ user.settings.quality ]" :style="{ zoom: app.zoom, '-moz-transform': 'scale(' + app.zoom + ')' }">
		<div v-if="lang && app_ready" class="app-content" :class="{ 'has-popup': app.popups.length }">

			<transition name="route" mode="out-in">
				<router-view class="router-view" />
			</transition>

			<div v-if="$route.name === 'game'" class="menu-button" v-hammer:tap="show_menu">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
			</div>

			<transition-group v-if="app.popups.length" name="popup" tag="div" appear class="popups">
				<popup v-for="popup in app.popups" :popup="popup" :key="popup.id" />
			</transition-group>

			<transition-group v-if="app.status_infos.length" name="status-info" tag="div" appear class="status-infos">
				<status-info v-for="status_info in app.status_infos" :status_info="status_info" :key="status_info.id" />
			</transition-group>
			
			<transition name="tuto" appear>
				<tuto v-if="app.tuto" :tuto="app.tuto" />
			</transition>

		</div>
		<loading-screen v-else />
		<div v-if="browser_alert && $route.name === 'home'" class="brower-alert">{{ 'brower_alert' | lang }}</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Popup from '@/components/global/popup'
import Tuto from '@/components/global/tuto'
import StatusInfo from '@/components/global/status-info'
import LoadingScreen from '@/components/loading-screen'
import DkHand from '@/assets/fonts/DK-Hand.ttf'

export default {
	name: 'app',
	data() {
		return {
			loading_start: null,
		}
	},
	computed: {
		...mapGetters([ 'lang', 'app', 'app_ready', 'user' ]),
		browser_alert() {
			return ! (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor))
		}
	},
	watch: {
		app_ready() {
			console.info('=== App loaded in ' + (Date.now() - this.loading_start) + 'ms ===')
		}
	},
	methods: {
		resize() {
			let zoom = 0
			const w = window.innerWidth
			const h = window.innerHeight

			if (w && h) {
				const max = 2
				for (var i = 0; i < max; i += 0.01) {
					if (i > (w / 1920) || i > (h / 1080)) {
						zoom = i.toFixed(2)
						break
					}
				}
				if (!zoom) zoom = max
			}

			this.$store.commit('EDIT_APP_STATE', { zoom })
		},
		fullscreen: function() {
			const elem = document.documentElement
			if (elem.requestFullscreen) elem.requestFullscreen()
			else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen()
			else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen()
			else if (elem.msRequestFullscreen) elem.msRequestFullscreen()
		},
		keypress(e) {
			if (e.keyCode === 27) {
				if (!this.app.tuto) {
					if (this.app.popups.length > 0) {
						this.$store.dispatch('remove_popup', { popup: this.app.popups[this.app.popups.length - 1], from: 'escape' })
					}
					else {
						this.show_menu()
					}
				}
			}
			if (e.keyCode === 70) this.fullscreen()
		},
		show_menu() {
			this.$store.dispatch('add_popup', { type: 'game-menu' })
		}
	},
	created() {
		this.loading_start = Date.now()
		this.resize()
		window.addEventListener('resize', this.resize)
		window.addEventListener('keyup', this.keypress)

		const font = new FontFace('DK-Hand', 'url(' + DkHand + ')')
		font.load().then((loaded_face) => {
			document.fonts.add(loaded_face)
			document.body.style.fontFamily = 'DK-Hand'
			this.$store.dispatch('init_app')
		}).catch(function(error) {
			console.error('loading font error', error)
		})
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resize)
		window.removeEventListener('keyup', this.keypress)
	},
	components: { Popup, StatusInfo, LoadingScreen, Tuto }
}
</script>

<style lang="stylus">
@import './assets/css/reset'

body
	background-color #111
	flex center center

#app
	width (1920px / 1)
	height (1080px / 1)
	overflow hidden
	box-shadow 0 0 0 3px #fff

	&.low
		.app-content.has-popup
			.router-view, .tuto
				filter none
			.popups
				.popup
					filter none

	.app-content
		&.has-popup
			&:after
				display none
			.router-view, .tuto
				filter blur(8px)
			.popups
				.popup
					// transition none
					// transition 0.1s linear
					filter blur(8px)
					&:last-child
						filter none

		.router-view
			&.route-enter-active, &.route-leave-active
				transition 0.15s easeOutQuart
			&.route-enter
				// transform translateY(-16px)
				opacity 0
			&.route-leave-to
				// transform translateY(16px)
				opacity 0
		> .popups
			absolute 0
			z-index 1
		> .status-infos
			position absolute
			right 48px
			top 48px
			width 420px
			z-index 1
			.status-info
				// margin 0 0 16px 0
				for i in 1..10
					&:nth-child({i})
						top (i * 16px)
						right (i * 16px)
						// left (i * 2px)

	.menu-button
		position absolute
		right 0
		top 0
		width 80px
		height 80px
		flex center center
		color #fff
		opacity 0.5
		&:hover
			opacity 1
		&:before
			content ''
			position absolute
			right 0
			top 0
			width 150px
			height 150px
			background linear-gradient(45deg, transparent 50%, alpha(#000, 50%) 100%)
			pointer-events none
		svg
			width 32px
			height 32px

.loading
	absolute 0
	background-color dark
	flex center center
	color light
	font-family sans-serif
	font-weight 900
	font-size 2rem
	
.brower-alert
	position absolute
	left 50%
	top 32px
	background-color alpha(red, 85%)
	transform translateX(-50%)
	font-size 2.6rem
	padding 16px 24px
	border-radius 8px
	color #fff



</style>
